const UTMScaleFactor = 0.9996;
const sm_a = 6378137.0;
const sm_b = 6356752.314;

function toRad(deg) {
  return (deg / 180.0 * Math.PI);
}

const L93_A = 6378137.0;
const L93_E = 0.0818191910428158;
const L93_LAT1 = toRad(44.0);
const L93_LAT2 = toRad(49.0);
const L93_LAT0 = toRad(46.5);
const L93_LON0 = toRad(3.0);
const L93_X0 = 700000.0;
const L93_Y0 = 6600000.0;

function l93T(phi) {
  return Math.tan((Math.PI / 4.0) + (phi / 2.0))
    * Math.pow((1.0 - L93_E * Math.sin(phi)) / (1.0 + L93_E * Math.sin(phi)), L93_E / 2.0);
}

const L93_M1 = Math.cos(L93_LAT1) / Math.sqrt(1.0 - (L93_E * L93_E) * Math.pow(Math.sin(L93_LAT1), 2.0));
const L93_M2 = Math.cos(L93_LAT2) / Math.sqrt(1.0 - (L93_E * L93_E) * Math.pow(Math.sin(L93_LAT2), 2.0));
const L93_T1 = l93T(L93_LAT1);
const L93_T2 = l93T(L93_LAT2);
const L93_T0 = l93T(L93_LAT0);
const L93_N = (Math.log(L93_M1) - Math.log(L93_M2)) / (Math.log(L93_T1) - Math.log(L93_T2));
const L93_F = L93_M1 / (L93_N * Math.pow(L93_T1, L93_N));
const L93_RHO0 = L93_A * L93_F * Math.pow(L93_T0, L93_N);

function UTMCentralMeridian(zone) {
    return toRad(-183.0 + (zone * 6.0));
}

function arcLengthOfMeridian(phi) {
  var alpha, beta, gamma, delta, epsilon, n;
  var result;

  /* Precalculate n */
  n = (sm_a - sm_b) / (sm_a + sm_b);

  /* Precalculate alpha */
  alpha = ((sm_a + sm_b) / 2.0)
      * (1.0 + (Math.pow(n, 2.0) / 4.0) + (Math.pow(n, 4.0) / 64.0));

  /* Precalculate beta */
  beta = (-3.0 * n / 2.0) + (9.0 * Math.pow(n, 3.0) / 16.0)
      + (-3.0 * Math.pow(n, 5.0) / 32.0);

  /* Precalculate gamma */
  gamma = (15.0 * Math.pow(n, 2.0) / 16.0)
      + (-15.0 * Math.pow(n, 4.0) / 32.0);

  /* Precalculate delta */
  delta = (-35.0 * Math.pow(n, 3.0) / 48.0)
      + (105.0 * Math.pow(n, 5.0) / 256.0);

  /* Precalculate epsilon */
  epsilon = (315.0 * Math.pow(n, 4.0) / 512.0);

  /* Now calculate the sum of the series and return */
  result = alpha
      * (phi + (beta * Math.sin(2.0 * phi))
          + (gamma * Math.sin(4.0 * phi))
          + (delta * Math.sin(6.0 * phi))
          + (epsilon * Math.sin(8.0 * phi)));

  return result;
  }

function mapLatLonToXY (phi, lambda, lambda0, xy) {
  var N, nu2, ep2, t, t2, l;
  var l3coef, l4coef, l5coef, l6coef, l7coef, l8coef;
  var tmp;

  /* Precalculate ep2 */
  ep2 = (Math.pow(sm_a, 2.0) - Math.pow(sm_b, 2.0)) / Math.pow(sm_b, 2.0);

  /* Precalculate nu2 */
  nu2 = ep2 * Math.pow(Math.cos(phi), 2.0);

  /* Precalculate N */
  N = Math.pow(sm_a, 2.0) / (sm_b * Math.sqrt(1 + nu2));

  /* Precalculate t */
  t = Math.tan(phi);
  t2 = t * t;
  tmp = (t2 * t2 * t2) - Math.pow(t, 6.0);

  /* Precalculate l */
  l = lambda - lambda0;

  /* Precalculate coefficients for l**n in the equations below
      so a normal human being can read the expressions for easting
      and northing
      -- l**1 and l**2 have coefficients of 1.0 */
  l3coef = 1.0 - t2 + nu2;
  l4coef = 5.0 - t2 + 9 * nu2 + 4.0 * (nu2 * nu2);
  l5coef = 5.0 - 18.0 * t2 + (t2 * t2) + 14.0 * nu2 - 58.0 * t2 * nu2;
  l6coef = 61.0 - 58.0 * t2 + (t2 * t2) + 270.0 * nu2 - 330.0 * t2 * nu2;
  l7coef = 61.0 - 479.0 * t2 + 179.0 * (t2 * t2) - (t2 * t2 * t2);
  l8coef = 1385.0 - 3111.0 * t2 + 543.0 * (t2 * t2) - (t2 * t2 * t2);

  /* Calculate easting (x) */
  xy[0] = N * Math.cos (phi) * l
      + (N / 6.0 * Math.pow(Math.cos(phi), 3.0) * l3coef * Math.pow(l, 3.0))
      + (N / 120.0 * Math.pow(Math.cos(phi), 5.0) * l5coef * Math.pow(l, 5.0))
      + (N / 5040.0 * Math.pow(Math.cos(phi), 7.0) * l7coef * Math.pow(l, 7.0));

  /* Calculate northing (y) */
  xy[1] = arcLengthOfMeridian(phi)
      + (t / 2.0 * N * Math.pow(Math.cos(phi), 2.0) * Math.pow(l, 2.0))
      + (t / 24.0 * N * Math.pow(Math.cos(phi), 4.0) * l4coef * Math.pow(l, 4.0))
      + (t / 720.0 * N * Math.pow(Math.cos(phi), 6.0) * l6coef * Math.pow(l, 6.0))
      + (t / 40320.0 * N * Math.pow(Math.cos(phi), 8.0) * l8coef * Math.pow(l, 8.0));
}

function latLngToUTMXY (lat, lon, zone, xy) {
    mapLatLonToXY(lat, lon, UTMCentralMeridian(zone), xy);

    /* Adjust easting and northing for UTM system. */
    xy[0] = xy[0] * UTMScaleFactor + 500000.0;
    xy[1] = xy[1] * UTMScaleFactor;
    if (xy[1] < 0.0)
        xy[1] = xy[1] + 10000000.0;

    return zone;
}


function FootpointLatitude(y) {
  var y_, alpha_, beta_, gamma_, delta_, epsilon_, n;
  var result;

  /* Precalculate n (Eq. 10.18) */
  n = (sm_a - sm_b) / (sm_a + sm_b);

  /* Precalculate alpha_ (Eq. 10.22) */
  /* (Same as alpha in Eq. 10.17) */
  alpha_ = ((sm_a + sm_b) / 2.0)
    * (1 + (Math.pow(n, 2.0) / 4) + (Math.pow(n, 4.0) / 64));

  /* Precalculate y_ (Eq. 10.23) */
  y_ = y / alpha_;


  /* Precalculate beta_ (Eq. 10.22) */
  beta_ = (3.0 * n / 2.0) + (-27.0 * Math.pow(n, 3.0) / 32.0)
    + (269.0 * Math.pow(n, 5.0) / 512.0);

  /* Precalculate gamma_ (Eq. 10.22) */
  gamma_ = (21.0 * Math.pow(n, 2.0) / 16.0)
    + (-55.0 * Math.pow(n, 4.0) / 32.0);

  /* Precalculate delta_ (Eq. 10.22) */
  delta_ = (151.0 * Math.pow(n, 3.0) / 96.0)
    + (-417.0 * Math.pow(n, 5.0) / 128.0);

  /* Precalculate epsilon_ (Eq. 10.22) */
  epsilon_ = (1097.0 * Math.pow(n, 4.0) / 512.0);

  /* Now calculate the sum of the series (Eq. 10.21) */
  result = y_ + (beta_ * Math.sin(2.0 * y_))
    + (gamma_ * Math.sin(4.0 * y_))
    + (delta_ * Math.sin(6.0 * y_))
    + (epsilon_ * Math.sin(8.0 * y_));

  return result;
}

function mapXYToLatLon(x, y, lambda0, philambda) {
  var phif, Nf, Nfpow, nuf2, ep2, tf, tf2, tf4, cf;
  var x1frac, x2frac, x3frac, x4frac, x5frac, x6frac, x7frac, x8frac;
  var x2poly, x3poly, x4poly, x5poly, x6poly, x7poly, x8poly;

  /* Get the value of phif, the footpoint latitude. */
  phif = FootpointLatitude(y);

  /* Precalculate ep2 */
  ep2 = (Math.pow(sm_a, 2.0) - Math.pow(sm_b, 2.0))
    / Math.pow(sm_b, 2.0);

  /* Precalculate cos (phif) */
  cf = Math.cos(phif);

  /* Precalculate nuf2 */
  nuf2 = ep2 * Math.pow(cf, 2.0);

  /* Precalculate Nf and initialize Nfpow */
  Nf = Math.pow(sm_a, 2.0) / (sm_b * Math.sqrt(1 + nuf2));
  Nfpow = Nf;

  /* Precalculate tf */
  tf = Math.tan(phif);
  tf2 = tf * tf;
  tf4 = tf2 * tf2;

  /* Precalculate fractional coefficients for x**n in the equations
     below to simplify the expressions for latitude and longitude. */
  x1frac = 1.0 / (Nfpow * cf);

  Nfpow *= Nf;   /* now equals Nf**2) */
  x2frac = tf / (2.0 * Nfpow);

  Nfpow *= Nf;   /* now equals Nf**3) */
  x3frac = 1.0 / (6.0 * Nfpow * cf);

  Nfpow *= Nf;   /* now equals Nf**4) */
  x4frac = tf / (24.0 * Nfpow);

  Nfpow *= Nf;   /* now equals Nf**5) */
  x5frac = 1.0 / (120.0 * Nfpow * cf);

  Nfpow *= Nf;   /* now equals Nf**6) */
  x6frac = tf / (720.0 * Nfpow);

  Nfpow *= Nf;   /* now equals Nf**7) */
  x7frac = 1.0 / (5040.0 * Nfpow * cf);

  Nfpow *= Nf;   /* now equals Nf**8) */
  x8frac = tf / (40320.0 * Nfpow);

  /* Precalculate polynomial coefficients for x**n.
     -- x**1 does not have a polynomial coefficient. */
  x2poly = -1.0 - nuf2;

  x3poly = -1.0 - 2 * tf2 - nuf2;

  x4poly = 5.0 + 3.0 * tf2 + 6.0 * nuf2 - 6.0 * tf2 * nuf2
    - 3.0 * (nuf2 * nuf2) - 9.0 * tf2 * (nuf2 * nuf2);

  x5poly = 5.0 + 28.0 * tf2 + 24.0 * tf4 + 6.0 * nuf2 + 8.0 * tf2 * nuf2;

  x6poly = -61.0 - 90.0 * tf2 - 45.0 * tf4 - 107.0 * nuf2
    + 162.0 * tf2 * nuf2;

  x7poly = -61.0 - 662.0 * tf2 - 1320.0 * tf4 - 720.0 * (tf4 * tf2);

  x8poly = 1385.0 + 3633.0 * tf2 + 4095.0 * tf4 + 1575 * (tf4 * tf2);

  /* Calculate latitude */
  philambda[0] = phif + x2frac * x2poly * (x * x)
    + x4frac * x4poly * Math.pow(x, 4.0)
    + x6frac * x6poly * Math.pow(x, 6.0)
    + x8frac * x8poly * Math.pow(x, 8.0);

  /* Calculate longitude */
  philambda[1] = lambda0 + x1frac * x
    + x3frac * x3poly * Math.pow(x, 3.0)
    + x5frac * x5poly * Math.pow(x, 5.0)
    + x7frac * x7poly * Math.pow(x, 7.0);

  return;
}

function utmxyToLatLng(x, y, zone, southhemi, latlon) {
  var cmeridian;

  x -= 500000.0;
  x /= UTMScaleFactor;

  /* If in southern hemisphere, adjust y accordingly. */
  if (southhemi)
    y -= 10000000.0;

  y /= UTMScaleFactor;

  cmeridian = UTMCentralMeridian(zone);
  mapXYToLatLon(x, y, cmeridian, latlon);

  return;
}

export function UTMToLatLng(zone, hemisphere, x, y) {
  const latlon = new Array(2);

  let isSouth = false;
  if (hemisphere === 'Sud' || hemisphere === 'S') {
    isSouth = true;
  } else if (typeof hemisphere === 'string' && hemisphere.length === 1) {
    const char = hemisphere.toUpperCase();
    if (char >= 'C' && char <= 'M') {
      isSouth = true;
    }
  }

  utmxyToLatLng(x, y, zone, isSouth, latlon);
  return {
    lat: latlon[0] * 180.0 / Math.PI,
    lng: latlon[1] * 180.0 / Math.PI
  };
}

export function UTM(lat, lng) {
  let xy = new Array(2);
  const zone = latLngToUTMXY(toRad(lat), toRad(lng), Math.floor((lng + 180.0) / 6) + 1, xy);
  const x = Math.round(xy[0]);
  const y = Math.round(xy[1]);

  let h = "Nord";
  
  if(lat < 0) {
    h = "Sud";
  } else if (lat >= 40 && lat < 48) {
    h = "T";
  } else if (lat >= 48 && lat < 56) {
    h = "U";
  }

  return `${zone}${h} ${x} ${y}`;
}

export function degrees2L93(lat, lon) {
  const phi = toRad(lat);
  const lambda = toRad(lon);
  const t = l93T(phi);
  const rho = L93_A * L93_F * Math.pow(t, L93_N);
  const theta = L93_N * (lambda - L93_LON0);
  const x = L93_X0 + (rho * Math.sin(theta));
  const y = L93_Y0 + L93_RHO0 - (rho * Math.cos(theta));

  return { x, y };
}

  export function DMS(deg) {
    const absolute = Math.abs(deg);
    const d = Math.floor(absolute);
    const minFloat = (absolute - d) * 60;
    const m = Math.floor(minFloat);
    const s = ((minFloat - m) * 60).toFixed(2);

    const sign = deg < 0 ? "-" : "";
    return `${sign}${d}° ${m}' ${s}"`;
  }

  export function DMM(deg) {
    const absolute = Math.abs(deg);
    const d = Math.floor(absolute);
    const min = ((absolute - d) * 60).toFixed(2);

    const sign = deg < 0 ? "-" : "";
    return `${sign}${d}° ${min}'`;
  }

  export function DMM_Cardinal(lat, lng) {
    const latAbs = Math.abs(lat);
    const latD = Math.floor(latAbs);
    const latM = ((latAbs - latD) * 60).toFixed(2);
    const latSign = lat >= 0 ? "N" : "S";

    const lngAbs = Math.abs(lng);
    const lngD = Math.floor(lngAbs);
    const lngM = ((lngAbs - lngD) * 60).toFixed(2);
    const lngSign = lng >= 0 ? "E" : "W";

    return `${latSign} ${latD} ${latM} ${lngSign} ${lngD} ${lngM}`;
  }
